// Time zones offered in forms: the browser's full list when available, else the usual European ones.

const FALLBACK = ['Europe/Paris', 'Europe/Brussels', 'Europe/Luxembourg', 'Europe/Zurich', 'Europe/Monaco', 'Europe/London',
  'Europe/Madrid', 'Europe/Berlin', 'Europe/Rome', 'America/Martinique', 'America/Guadeloupe', 'America/Cayenne',
  'Indian/Reunion', 'Indian/Mayotte', 'Pacific/Noumea', 'Pacific/Tahiti', 'America/Montreal', 'UTC'];

export const TIME_ZONES: string[] = (() => {
  const intl = Intl as unknown as { supportedValuesOf?: (key: string) => string[] };
  try {
    return intl.supportedValuesOf?.('timeZone') ?? FALLBACK;
  } catch {
    return FALLBACK;
  }
})();
